import { defaultLocale } from '../../utils/i18next';

export interface LocaleState {
  isRtl: boolean;
  language: string;
}

export const initialLocaleState: LocaleState = {
  language: defaultLocale,
  isRtl: false,
};
